module.exports = __webpack_public_path__ + "img/og_image.ed01fbd.png";